module.exports = __webpack_public_path__ + "img/1d91c21.jpg";